import {
  ComponentType,
  Overlay,
  OverlayRef,
  ScrollStrategyOptions,
} from '@angular/cdk/overlay';
import { ComponentPortal, TemplatePortal } from '@angular/cdk/portal';
import {
  Injectable,
  Injector,
  TemplateRef,
  Type,
  ViewContainerRef,
} from '@angular/core';
import { DIALOG_DATA } from '../../../../global.variable';
import { DialogRef } from './modal-dialogue.ref';
export interface DialogConfig {
  data?: any;
}

@Injectable({
  providedIn: 'root',
})
export class ModalDialogueService {
  componentFactoryResolver: any;
  openDialogs: DialogRef[] = [];

  activeOverlays = new Set<OverlayRef>();

  constructor(
    private overlay: Overlay,
    private injector: Injector,
    private scrollStrategyOptions: ScrollStrategyOptions,
  ) {}

  open<T>(
    componentOrTemplate: ComponentType<T> | TemplateRef<T> | any,
    config?: DialogConfig,
    viewContainerRef: ViewContainerRef | any = '',
  ): DialogRef {
    const scrollStrategy = this.scrollStrategyOptions.block();
    const positionStrategy = this.overlay
      .position()
      .global()
      .centerHorizontally()
      .centerVertically();
    const overlayRef = this.overlay.create({
      positionStrategy,
      hasBackdrop: true,
      backdropClass: 'overlay-backdrop',
      panelClass: 'overlay-panel',
      scrollStrategy: scrollStrategy,
      disposeOnNavigation: true,
    });
    const dialogRef = new DialogRef(overlayRef);
    this.openDialogs.push(dialogRef);
    const injector = Injector.create({
      parent: this.injector,
      providers: [
        { provide: DialogRef, useValue: dialogRef },
        { provide: DIALOG_DATA, useValue: config?.data },
      ],
    });

    // Attach component portal to the overlay
    if (this.isComponentType(componentOrTemplate)) {
      const componentPortal = new ComponentPortal(
        componentOrTemplate as Type<T>,
        null,
        injector,
      );
      overlayRef.attach(componentPortal);
    } else {
      overlayRef.attach(
        new TemplatePortal(componentOrTemplate, viewContainerRef, {
          $implicit: config?.data,
          dialogRef: dialogRef,
        } as any),
      );
    }
    return dialogRef;
  }

  private isComponentType(value: any): value is ComponentType<any> {
    return value && value.prototype && value.prototype.ngOnInit;
  }
  closeAll(): void {
    this.openDialogs?.forEach((dialog) => dialog?.close());
    this.openDialogs = [];

    this.activeOverlays.forEach((overlay) => {
      if (overlay && typeof overlay.dispose === 'function') {
        overlay.dispose(); // Destroys DOM nodes permanently
      }
    });
    this.activeOverlays.clear();
  }
  register(overlayRef: OverlayRef): void {
    this.activeOverlays.add(overlayRef);
  }

  // Remove tracking once an overlay closes naturally
  deregister(overlayRef: OverlayRef): void {
    this.activeOverlays.delete(overlayRef);
  }
}
